import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Event } from '@interfaces';
import { AppService } from '../../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {

	const columns: GridColumn<Event, unknown>[] = [
		buildColumn(util, 'Id', row => row.eventId, { header: 'Event ID' }),
		buildColumn(util, 'Id', row => row.accId, { header: 'Acc ID' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'Accelerator' }),
		buildColumn(util, 'Text', row => row.eventName, { header: 'Event Name' }),
		buildColumn(util, 'Text', row => app.getStaffNameById(row.facilitatorId), { header: 'Facilitator' }),
		buildColumn(util, 'Status', row => row.status, { header: 'Status' }),
		buildColumn(util, 'Text', row => row.eventType, { header: 'Event Type' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.startUTC), { header: 'Start Time' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.endUTC), { header: 'End Time' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.toolStartUTC), { header: 'Tool Start Time', hidden: true }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.toolEndUTC), { header: 'Tool End Time', hidden: true }),
		buildColumn(util, 'Text', row => row.venue, { header: 'Venue', hidden: true }),
		buildColumn(util, 'Text', row => util.date.calculateTimePeriod(row.startUTC, row.endUTC), { header: 'Duration', hidden: true }),
		buildColumn(util, 'Text', row => row.hostName, { header: 'Host', hidden: true }),
	];


	return columns;

}